import { withErrorBoundary } from '../dependencies';

import ReportBarChart from '../components/ReportBarChart';

export default withErrorBoundary(ReportBarChart);
